<template>
  <div class="dados">
    <h1 class="font-weight-bold text-uppercase px-3">Meus Dados</h1>
    <hr class="linha-amarela" />
    <div class="col-12">
      <i class="fas fa-sign-in-alt fa-2x c-orange mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Dados de Acesso
      </h4>
      <div class="row mt-3">
        <div class="form-group col-6">
          <label class="font-weight-bold"> Email: </label>
          <span type="text" id="email" name="email" placeholder="">
            {{ Fields.partner.email }}
          </span>
        </div>
      </div>
    </div>
    <div>
      <hr />
    </div>
    <div class="col-12">
      <i class="fas fa-user-circle c-orange fa-2x mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Dados da Conta
      </h4>
      <div class="row mt-3">
        <div class="row col-12 mb-2">
          <div class="form-group col-3">
            <label for="nome" class="font-weight-bold"> Nome: </label>
            <span
              type="text"
              id="nome"
              name="nome"
              disabled
              placeholder=""
              class="d-block"
            >
              {{ Fields.partner.nome }}
            </span>
          </div>
          <div class="col-3" v-if="Fields.partner.rg">
            <label for="rg" class="font-weight-bold"> RG: </label>
            <span
              type="text"
              id="nome"
              name="nome"
              placeholder=""
              class="d-block"
            >
              {{ Fields.partner.rg }}
            </span>
          </div>
          <div class="col-3" v-if="Fields.partner.cpf">
            <label for="cpf" class="font-weight-bold"> CPF: </label>
            <span
              type="text"
              id="nome"
              name="nome"
              placeholder=""
              class="d-block"
            >
              {{ Fields.partner.cpf }}
            </span>
          </div>
          <div class="col-3" v-if="Fields.partner.cnpj">
            <label for="cnpj" class="font-weight-bold"> CNPJ: </label>
            <span
              type="text"
              id="nome"
              name="nome"
              placeholder=""
              class="d-block"
            >
              {{ Fields.partner.cnpj }}
            </span>
          </div>
        </div>
        <div class="row col-12">
          <div class="form-group col-12 col-md-4">
            <label for="whatsapp" class="font-weight-bold"> Whatsapp: </label>
            <input
              type="text"
              class="form-control"
              id="whatsapp"
              name="whatsapp"
              v-model="Fields.contact.celular"
              v-mask="['(##) #####-####', '(##) ####-####']"
              @input="ErrorMessages.phone = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.phone !== null"
            >
              {{ ErrorMessages.phone }}
            </p>
          </div>
          <div class="form-group col-12 col-md-4">
            <label for="telefone" class="font-weight-bold"> Telefone: </label>
            <input
              type="text"
              class="form-control"
              id="telefone"
              name="telefone"
              v-model="Fields.contact.telefone"
              v-mask="['(##) #####-####', '(##) ####-####']"
              @input="ErrorMessages.telephone = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.telephone !== null"
            >
              {{ ErrorMessages.telephone }}
            </p>
          </div>
          <div class="form-group col-12 col-md-4">
            <label for="telefone2" class="font-weight-bold">
              Telefone 2:
            </label>
            <input
              type="text"
              class="form-control"
              id="telefone2"
              name="telefone2"
              v-model="Fields.contact.telefone2"
              v-mask="['(##) #####-####', '(##) ####-####']"
              @input="ErrorMessages.telephone2 = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.telephone2 !== null"
            >
              {{ ErrorMessages.telephone2 }}
            </p>
          </div>
        </div>
      </div>
      <b-button
        variant="success"
        type="submit"
        class="my-3 text-uppercase"
        @click="updateTelephone()"
      >
        Atualizar Dados
      </b-button>
    </div>
    <!-- Endereço do Afiliado -->
    <div>
      <hr />
    </div>
    <Address
      ref="address"
      :cep="Fields.partner.cep"
      :address="Fields.partner.endereco"
      :number="Fields.partner.numero"
      :neighborhood="Fields.partner.bairro"
      :cityId="Fields.partner.cidade_id"
      :complement="Fields.partner.complemento"
    />
    <div>
      <hr />
    </div>
    <div class="col-12">
      <i class="far fa-address-card c-orange fa-2x mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">Sobre</h4>
      <div class="row mt-3">
        <div class="form-group col-12 col-md-4">
          <label class="d-block font-weight-bold" for="cidades">
            Cidades de Atuação:
          </label>
          <span
            v-for="(cidade_atuacao, index) in getPartner.cidades_atuacao"
            :key="index"
          >
            {{ cidade_atuacao.nome }}
            {{ !(index + 1 === getPartner.cidades_atuacao.length) ? ',' : '' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
// import SalesPortfolio from '../../enums/partner/SalesPortfolio';
import Address from '../../components/partner/Address.vue';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'partnerData',
  components: {
    Address,
  },
  data() {
    return {
      Fields: {
        partner: {},
        contact: {},
      },
      ErrorMessages: {
        phone: null,
        telephone: null,
        telephone2: null,
        neighborhood: null,
        city: null,
        // cep: null,
        complement: null,
        number: null,
        address: null,
      },
      // SalesPortfolio,
    };
  },
  mixins: [makeToast],
  computed: {
    ...mapState(['dadosUsuario', 'cidades']),
    ...mapGetters('partner', ['getPartner']),
  },
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('startLoader');
    this.get(this.dadosUsuario.informacoes.id)
      .then(() => {
        this.Fields.partner = this.getPartner;
      })
      .finally(() => this.$store.dispatch('endLoader'));

    this.getContact(this.dadosUsuario.informacoes.usuario_id).then(
      (response) => {
        this.Fields.contact = response.data;
      }
    );
  },
  methods: {
    ...mapActions('partner', ['get', 'getContact', 'updateTelephones']),
    updateTelephone() {
      if (this.validateFields()) {
        this.$store.dispatch('startLoader');

        const data = {
          id: this.Fields.partner.usuario_id,
          phone: this.Fields.contact.celular,
          telephone: this.Fields.contact.telefone,
          telephone2: this.Fields.contact.telefone2,
        };

        this.updateTelephones(data)
          .then((response) => {
            this.makeToast('Sucesso!', response.data.message);
          })
          .catch((error) => {
            this.makeToast('Oops!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      }
    },
    validateFields() {
      let isValid = true;

      if (!this.$validate.telephone(this.Fields.contact.celular)) {
        this.ErrorMessages.phone = 'Celular inválido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.contact.telefone)) {
        this.ErrorMessages.telephone = 'Telefone inválido';
        isValid = false;
      }

      if (
        this.Fields.contact.telefone2 !== null &&
        this.Fields.contact.telefone2 !== '' &&
        !this.$validate.telephone(this.Fields.contact.telefone2)
      ) {
        this.ErrorMessages.telephone2 = 'Telefone 2 inválido';
        isValid = true;
      }

      return isValid;
    },
  },
};
</script>
